import { svgsIndex } from "facesjs";

const isValidJersey = (jersey: unknown) => {
	if (typeof jersey !== "string") {
		return false;
	}

	return svgsIndex.jersey.includes(jersey as any) && jersey.startsWith("jersey");
};

export default isValidJersey;
